var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './gallery.styles';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { dictionary } from '@mf-cms/helpers';
import { classMap } from 'lit/directives/class-map.js';
import { MFElement } from '../mfelement/mfelement';
let PGallery = class PGallery extends MFElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
        this.layout = 1;
        this.textAlign = 'left';
        this.useLightbox = false;
        this.handleSlotChange = () => {
            if (!this.useLightbox)
                return;
            if (this.lightbox)
                this.lightbox.destroy();
            const data = [];
            const slot = this.shadowRoot.querySelector('slot:not([name])');
            const items = slot.assignedElements({ flatten: true }).filter((item) => item.tagName.toLowerCase() === 'p-gallery-item' && item.getAttribute('image'));
            for (const item of items) {
                data.push({
                    src: item.getAttribute('gallery-image'),
                    width: parseInt(item.getAttribute('ps-width')),
                    height: parseInt(item.getAttribute('ps-height')),
                    alt: item.getAttribute('alt')
                });
            }
            this.lightbox = new PhotoSwipeLightbox({
                dataSource: data,
                pswpModule: PhotoSwipe,
                closeTitle: dictionary(this.culture, 'lightbox', 'close'),
                zoomTitle: dictionary(this.culture, 'lightbox', 'zoom'),
                arrowPrevTitle: dictionary(this.culture, 'lightbox', 'previous'),
                arrowNextTitle: dictionary(this.culture, 'lightbox', 'next'),
                errorMsg: dictionary(this.culture, 'lightbox', 'error')
            });
            this.lightbox.init();
            for (const [index, item] of items.entries()) {
                item.onclick = () => this.lightbox?.loadAndOpen(index);
                item.tabIndex = 0;
                item.onkeydown = (event) => {
                    if (event.key === 'Enter') {
                        this.lightbox?.loadAndOpen(index);
                    }
                };
            }
        };
    }
    static { this.styles = styles; }
    firstUpdated() {
        super.connectedCallback();
        const slot = this.shadowRoot.querySelector('slot:not([name])');
        slot.addEventListener('slotchange', this.handleSlotChange);
        this.handleSlotChange();
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const classes = {
            [`layout-${this.layout}`]: true,
            ['use-lightbox']: this.useLightbox,
            ['text-align-' + this.textAlign]: true
        };
        return html ` <section class="gallery${classMap(classes)}"> <div class="container"> ${this.hideHeader ? '' : html `
                <div class="header text-align-${this.textAlign}">
                  <slot name="header"></slot>
                </div>
              `}
          <div class="gallery-wrap">
            <slot></slot>
          </div>
          ${this.caption
            ? html `<figcaption><div class="text">${this.caption}</figcaption></div>`
            : ''}
        </div>
      </section>
    `;
    }
};
__decorate([
    property({ type: String })
], PGallery.prototype, "culture", void 0);
__decorate([
    property({ type: String })
], PGallery.prototype, "caption", void 0);
__decorate([
    property({ type: Number, reflect: true })
], PGallery.prototype, "layout", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'text-align' })
], PGallery.prototype, "textAlign", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'hide-header' })
], PGallery.prototype, "hideHeader", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'use-lightbox' })
], PGallery.prototype, "useLightbox", void 0);
PGallery = __decorate([
    customElement('p-gallery')
], PGallery);
export { PGallery };
